import React from 'react';

//styles
import styles from "../AddBlog/AddBlog.module.css"

//images
import trashIcon from "../../../../assets/img/DashboardICons/TrashIcon.svg"

const AddedImg = (props) => {
    const removeHandler = () => {
        props.setImages(false)
    };
    return (
        <>
            <div className={`w-100 mt-2 d-flex justify-content-center align-items-center flex-wrap ${styles.img_container}`} >
                <div className='w-100 d-flex align-items-center justify-content-center flex-wrap'>
                    <div className="w-100 position-relative d-flex flex-column align-items-center justify-content-center m-0">
                        <img className={styles.uploaded_img} src={`https://backdev.azrmelk.com/magAssets/img/Articles/${props.images}`} alt="uploaded-img" />
                        <div className={`d-flex align-items-center justify-content-center ${styles.remove_img_container}`}>
                            <img onClick={removeHandler} src={trashIcon} alt="icon" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddedImg;